import { Link } from 'react-router-dom';

import { Layout, Menu } from 'antd';

import useGlobalConfig from '@/store/global';

const { Header } = Layout;

const LayoutHeader = () => {
  const { themeColor, programLogo, manufacturerLogo, updateMeData } = useGlobalConfig();
  const Authorization = localStorage.getItem('Authorization');

  return (
    <>
      <Header
        style={{
          background: '#cccccc',
          padding: 0,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '54px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            paddingLeft: '20px',
          }}
        >
          <img src={manufacturerLogo} alt="Medmonk Logo" style={{ height: '22px' }} />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            color: '#FFFFFF',
            fontSize: '30px',
            fontWeight: 700,
            paddingRight: '30px',
          }}
        >
          <img
            className="pointer-events-none"
            src="/images/medmonk-logo-white.png"
            alt="Medmonk Logo"
            style={{ height: '36px' }}
          />
        </div>
      </Header>
      <Header
        style={{
          background: themeColor, // 绿色背景
          padding: 0,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
            height: '100%',
            padding: '0 20px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Menu
              mode="horizontal"
              style={{
                background: 'transparent',
                border: 'none',
                color: 'white',
              }}
            >
              <Menu.Item key="contact">
                <Link to="/patient/contact" style={{ color: 'white' }}>
                  Contact Us
                </Link>
              </Menu.Item>
              <Menu.Item key="prescribing">
                <Link
                  to={Authorization ? '/patient/assistance_request/index' : '/'}
                  style={{ color: 'white' }}
                >
                  Important Safety Information
                </Link>
              </Menu.Item>
            </Menu>
          </div>
        </div>
      </Header>
      <div className="mx-auto flex flex-col md:flex-row items-center justify-between py-10 max-w-screen-xl px-5">
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <a href="/">
            <img src={programLogo} alt="Medmonk Logo" style={{ height: '100px' }} />
          </a>
        </div>

        {Authorization ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              className="mr-5 rounded px-4 py-2 text-white"
              style={{ backgroundColor: themeColor }}
              onClick={() => (window.location.href = '/patient_users/edit')}
            >
              Edit Patient Profile
            </button>
            <button
              className="rounded px-4 py-2 text-white"
              style={{ backgroundColor: themeColor }}
              onClick={() => {
                localStorage.removeItem('Authorization');
                localStorage.removeItem('Email');
                updateMeData({});
                window.location.href = '/';
              }}
            >
              Logout {localStorage.getItem('point_of_contact')}
            </button>
          </div>
        ) : (
          <button
            className="rounded px-4 py-2 text-white"
            style={{ backgroundColor: themeColor }}
            onClick={() => (window.location.href = '/patient/signin')}
          >
            Patient Login
          </button>
        )}
      </div>
    </>
  );
};

export default LayoutHeader;
